import {
  styleCss,
  styleMainHeaderCss,
  styleColumnHeaderCss,
  aligmentCss,
  columns,
} from "../ExportToExcelConstants";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import { RecordVoiceOverRounded } from "@mui/icons-material";

const participationTypeList = {
  202209: "Combine Invite",
  202221: "Elite Camp Invite",
  202222: "G League Ignite",
  202211: "Basketball Africa League",
  202309: "Combine Invite",
  202321: "Elite Camp Invite",
  202322: "G League Ignite",
  202311: "Basketball Africa League",
  202409: "Combine Invite",
  202421: "Elite Camp Invite",
  202422: "G League Ignite",
  202411: "Basketball Africa League",
};

const highSchoolEventConst = [
  "McDonalds All America",
  "Hoop Summit",
  "Jordan Brand Classic",
  "Test",
];

const rankingsConst = ["247", "ESPN", "Rivals", "RSCI"];

export const exportPlayerProfileDataToExcel = (
  playerData,
  lengthUnits,
  weightUnits,
  getWeightUnitValue,
  getLengthUnitValue,
  getWeightUnitLabelType
) => {
  let combineDetails1 = [];
  let combineDetails2 = [];
  let agentDetailsColumns = [];
  let collegeExperienceColumns = [];
  let highSchoolDetailsColumns = [];
  let aauClubPrograms = [];
  let professionalExperience = [];
  let gLeagueExperience = [];
  let internationalTeamExperience = [];
  let highSchoolEvents = [];
  let rankings = [];

  columns.PlayerProfile.CombineDetails1.forEach((elem) => {
    combineDetails1.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.CombineDetails2.forEach((elem) => {
    combineDetails2.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.AgentDetails.forEach((elem) => {
    agentDetailsColumns.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.CollegeExperience.forEach((elem) => {
    collegeExperienceColumns.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.HighSchoolDetails.forEach((elem) => {
    highSchoolDetailsColumns.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.AAUClubPrograms.forEach((elem) => {
    aauClubPrograms.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.ProfessionalExperience.forEach((elem) => {
    professionalExperience.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.GLeagueExperience.forEach((elem) => {
    gLeagueExperience.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.InternationalTeamExperience.forEach((elem) => {
    internationalTeamExperience.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  columns.PlayerProfile.HighSchoolEvents.forEach((elem) => {
    highSchoolEvents.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  let highSchoolEventsDataArray = highSchoolEventConst.map((elem, i) => {
    return [
      {
        value: highSchoolEventConst[i],
        style: styleCss,
        alignment: aligmentCss,
      },
      {
        value: "--",
        style: styleCss,
        alignment: aligmentCss,
      },
    ];
  });
  playerData.highSchoolEvents.forEach((record) => {
    highSchoolEventsDataArray.forEach((elem, i) => {
      highSchoolEventsDataArray[record.hsEventId - 1][1].value =
        record.eventYear ? record.eventYear : "--";
    });
  });

  columns.PlayerProfile.Rankings.forEach((elem) => {
    rankings.push({
      title: elem.title,
      width: { wpx: elem.width },
      style: styleColumnHeaderCss,
    });
  });

  let rankingsDataArray = rankingsConst.map((elem, i) => {
    return [
      {
        value: rankingsConst[i],
        style: styleCss,
        alignment: aligmentCss,
      },
      {
        value: "--",
        style: styleCss,
        alignment: aligmentCss,
      },
    ];
  });
  playerData.ranking.forEach((record) => {
    rankingsDataArray.forEach((elem, i) => {
      rankingsDataArray[record.rankItemId - 1][1].value = record.rankNumber
        ? record.rankNumber
        : "--";
    });
  });

  const dataSetForDownload = [
    {
      columns: [
        {
          title: "Combine Details",
          width: { wpx: 200 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: combineDetails1,
      data: playerData.participate.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.CombineDetails1.forEach((elem) => {
          if (elem.title === "Participation Type") {
            dataArray.push({
              value: participationTypeList[parseInt(record.eventId)]
                ? participationTypeList[parseInt(record.eventId)]
                : "--",
              style: styleCss,
              alignment: aligmentCss,
            });
          }
          if (elem.title === "Jersey Number") {
            dataArray.push({
              value: record.jersey?.toString() ?? "--",
              style: styleCss,
              alignment: aligmentCss,
            });
          }
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: combineDetails2,
      data: [
        [
          {
            value: playerData.dob
              ? moment(playerData.dob).format("MM/DD/YYYY")
              : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.twitter ? playerData.twitter : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.instagram ? playerData.instagram : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.heightInFeet
              ? `${getLengthUnitValue(
                  playerData.heightInFeet,
                  playerData.heightInInches
                )}`
              : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.positionName ? playerData.positionName : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.weight
              ? `${getWeightUnitValue(
                  playerData.weight
                )} ${getWeightUnitLabelType(weightUnits)}`
              : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
          {
            value: playerData.address1 ? playerData.address1 : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
        ],
      ],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "Agent Details",
          width: { wpx: 200 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: agentDetailsColumns,
      data: playerData.agent.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.AgentDetails.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "College Experience",
          width: { wpx: 200 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: collegeExperienceColumns,
      data: playerData.college.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.CollegeExperience.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "High School Details",
          width: { wpx: 200 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: highSchoolDetailsColumns,
      data: playerData.highSchool.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.HighSchoolDetails.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "AAU/Club Programs",
          width: { wpx: 200 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: aauClubPrograms,
      data: playerData.aauClub.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.AAUClubPrograms.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "International/Professional Experience",
          width: { wpx: 250 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: professionalExperience,
      data: playerData.intProfExperience.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.ProfessionalExperience.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "G League Experience",
          width: { wpx: 250 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: gLeagueExperience,
      data: playerData.gLeagueExperience.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.GLeagueExperience.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "National/International Team Experience",
          width: { wpx: 290 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: internationalTeamExperience,
      data: playerData.nationalIntExp.map((record) => {
        let dataArray = [];
        columns.PlayerProfile.InternationalTeamExperience.forEach((elem) => {
          dataArray.push({
            value: record[elem.field] ? record[elem.field].toString() : "--",
            style: styleCss,
            alignment: aligmentCss,
          });
        });
        return dataArray;
      }),
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "High School Events",
          width: { wpx: 250 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: highSchoolEvents,
      data: highSchoolEventsDataArray,
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "Rankings",
          width: { wpx: 250 },
          style: styleMainHeaderCss,
        },
      ],
      data: [],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: [
        {
          title: "Year",
          width: { wpx: 200 },
          style: styleColumnHeaderCss,
        },
      ],
      data: [
        [
          {
            value:
              playerData.ranking.length && playerData.ranking[0].rankYear
                ? playerData.ranking[0].rankYear
                : "--",
            style: styleCss,
            alignment: aligmentCss,
          },
        ],
      ],
    },
    {
      columns: [],
      data: [],
    },
    {
      columns: rankings,
      data: rankingsDataArray,
    },
  ];
  return dataSetForDownload;
};
